import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// Partially matches every message query of the session, whatever page or filter
export const getAdvancingMessagesQueryKey = (advancingSessionId: number) => ["AdvancingSession.PaginatedMessage", { advancingSessionId }];

export const advancingMessageMutationKey = ["AdvancingSession.Message"];

export const getAdvancingMessageToastId = (advancingMessageId: number) => `advancing-message-${advancingMessageId}`;

export const useMarkAdvancingMessageSeen = (advancingSessionId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: advancingMessageMutationKey,
    mutationFn: (advancingMessageId: number) => window.CoreApi.AdvancingSession.MessageSeen(advancingMessageId, { toastOnError: true }).then(r => r.data),
    onSuccess: async (response, advancingMessageId) => {
      if (response.hasErrors) return;
      // Also closes the toast when the message is marked seen in the chat panel
      toast.dismiss(getAdvancingMessageToastId(advancingMessageId));
      await queryClient.invalidateQueries({ queryKey: getAdvancingMessagesQueryKey(advancingSessionId) });
    }
  });
};
